/**
 * Close Account modal.
 *
 * @todo - Currently, the module's markup is added directly in Divi and resides
 *         in the database. Move markup to a PHP template.
 */
import iframe from '../components/iframe';
import dom from '../helpers/dom';
import environment from '../../../../../../../mu-plugins/qustodio-core/assets/src/js/public/helpers/environment';

const closeAccount = () => {
  const iframeClass = 'close-account-modal';
  const popupClass = 'popup_outer_wrap';
  const closeButtonClass = 'da-close';
  const dismissModalMessage = 'close-account-modal-dismiss';
  let iframeElements = [];
  let popupElement;
  let popupCloseButtonElement;

  const closePopup = () => {
    popupCloseButtonElement.dispatchEvent('click');
  };

  const onReceiveMessageFromIframe = (e) => {
    const origin = e?.originalEvent?.origin;
    const message = e?.originalEvent?.data;
    if (origin === environment.getSSOUrl() && message === dismissModalMessage) {
      closePopup();
    }
  };

  const init = () => {
    iframeElements = dom.getByClassName(iframeClass);
    [popupElement] = dom.getByClassName(popupClass);

    if (iframeElements !== null && popupElement !== null) {
      [popupCloseButtonElement] = dom.getByClassName(closeButtonClass, popupElement);

      iframeElements.forEach((iframeElement) => iframe(iframeElement));

      window.addEventListener('message', onReceiveMessageFromIframe);
    }
  };

  return {
    init,
  };
};

export default closeAccount();
